import React from "react";
import { Alert, Typography } from "@mui/material";

const CreateClubAuthPrompt: React.FC = () => (
  <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
      Sign in or create an account to set up your club
    </Typography>
    <Typography variant="body2">
      You need an Easy Agility Hub account before you can create a club. Sign in
      below if you already have one, or create a new account to get started.
    </Typography>
  </Alert>
);

export default CreateClubAuthPrompt;
